import { render, staticRenderFns } from "./PaymentPlanPreview.vue?vue&type=template&id=48f05974&scoped=true&"
import script from "./PaymentPlanPreview.vue?vue&type=script&lang=js&"
export * from "./PaymentPlanPreview.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPlanPreview.vue?vue&type=style&index=0&id=48f05974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f05974",
  null
  
)

export default component.exports